module.exports = __webpack_public_path__ + "static/media/xls.64643c1b.svg";